import React from 'react';

import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';

interface BonusBanner {
    highlighted_main_text?: string;
    main_text?: string;
    additional_text1?: string;
    additional_text2?: string;
}

interface BonusDetails {
    value?: number | string;
    count?: number | string;
    ccyIso?: string;
}

interface BonusReferralInfo {
    referralInfo?: {
        bonus?: BonusDetails;
    };
}

const getAdditionalSecondaryText = (text?: string): React.ReactNode => {
    if (text) {
        return <p>{text}</p>;
    }
    return false;
};

export const getHeaderText = (banner: BonusBanner = {}): JSX.Element => (
    <>
        <span>{banner.highlighted_main_text}</span>
        {' ' + banner.main_text}
    </>
);

export const getSecondaryText = (banner: BonusBanner = {}): JSX.Element => (
    <>
        {getAdditionalSecondaryText(banner.additional_text1)}
        {getAdditionalSecondaryText(banner.additional_text2)}
    </>
);

export const getMaxPossibleAmount = (lang: string, country: string, bonusReferralInfo?: BonusReferralInfo): string | null => {
    const amount = Number(bonusReferralInfo?.referralInfo?.bonus?.value) * Number(bonusReferralInfo?.referralInfo?.bonus?.count);
    return getLocalizedRawAmount(lang, country, amount, 2, true);
};

export const getAmountPerReferralUser = (lang: string, country: string, bonusReferralInfo?: BonusReferralInfo): string | null => {
    return getLocalizedRawAmount(lang, country, bonusReferralInfo?.referralInfo?.bonus?.value, 2, true);
};
